module.exports = __webpack_public_path__ + "img/handcraft_xl.eb985c0.webp";